import { mdiHome, mdiLogout, mdiMenu, mdiMenuDown, mdiMenuUp } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Drawer, Menu, notification } from "antd";
import React from "react";
import type { MenuProps } from 'antd';
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserApi from "../../api-services/user-api.service";

type MenuItem = Required<MenuProps>['items'][number];


function withLocation(Component) {
  return props => <Component {...props} location={useLocation()} navigate={useNavigate()} isUserSignedIn={props.isUserSignedIn} username={props.username}/>;
}



class Header extends React.Component <{location, navigate, isUserSignedIn, username}> {

  PartnerSignInButton(id:string){
    return <Button href="/web/sign-in" className="sign-in" id={id} type="primary"> partner sign in</Button>;
  }
  
  SignOutButton(id:string){
    const truncateLength = 12;
    const { username } = this.props;
    const truncatedName = username && username.length > truncateLength
      ? username.substring(0, truncateLength) + "..."
      : (username || "");

    return <div className="sign-out" id={id}> <div>hi, <span className="username">{truncatedName}</span></div> <span className="logout-icon" onClick={()=>this.logout()}><Icon title="Logout" path={mdiLogout} size="16px" /></span> </div>
  }

  items: MenuItem[] = [
    {
      key: 'web',
      label: <Link to="/web"> <span className="nav-menu-home-label"> <Icon path={mdiHome} size="25px" /> <span>Home</span> </span> </Link>
    },
    {
      key: 'series-tour',
      label: <span>Series Tour <Icon path={mdiMenuDown} size="20px" /></span>,
      children: [
        {
          key: 'gd-classics',
          label: <Link to="/web/series-tour/gd-classics"> GD Classic </Link>
        },
        // {
        //   key: 'gd-indepth',
        //   label: <Link to="/web/series-tour/gd-indepth"> GD In Depth </Link>
        // }
      ]
    },
    // {
    //   key: 'cruises',
    //   label: <span>Cruises <Icon path={mdiMenuDown} size="20px" /></span>,
    //   children:[
    //     {
    //       key: 'world-cruises',
    //       label: <Link to="web/cruises"> Cruise </Link>
    //     },
    //     {
    //       key: 'fly-cruises',
    //       label: <Link to="web/fly-cruises"> Fly Cruise </Link>
    //     },
    //   ]
    // },
    // {
    //   key: 'ground',
    //   label: <Link to="web/trips"> Ground </Link>
    // },
    // {
    //   key: 'gd-flight',
    //   label: <span>GD Flight <Icon path={mdiMenuDown} size="20px" /></span>,
    //   children: [
    //     {
    //       key: 'gd-flight-about',
    //       label: <Link to="/web/about-gd-flight"> About </Link>
    //     },
    //     {
    //       key: 'gd-flight-contact-agent',
    //       label: <Link to="/web/gd-flight-agents"> Contact Agents </Link>
    //     },
    //   ]
    // },
    // {
    //   key: 'mice',
    //   label: <span>Mice <Icon path={mdiMenuDown} size="20px" /></span>,
    //   children: [
    //     {
    //       key: 'mice-about',
    //       label: <Link to="web/mice/about"> About MICE </Link>
    //     },
    //     {
    //       key: 'mice-agent-registration',
    //       label: <Link to="web/mice/agent-registration"> Agent Registration </Link>
    //     },
    //     {
    //       key: 'mice-enquiries',
    //       label: <Link to="web/mice/enquiry"> Enquiries </Link>
    //     },
    //   ]
    // },
    // {
    //   key: 'gd-domestic',
    //   label: <Link to="web/domestic"> GD Domestic </Link>
    // },
    // {
    //   key: 'media',
    //   label: <span>Media <Icon path={mdiMenuDown} size="20px" /></span>,
    //   children: [
    //     {
    //       key: 'media-news-and-blogs',
    //       label: <Link to="web/blogs"> News & Blog </Link>
    //     },
    //     { 
    //       key: 'media-whats-new',
    //       label: <Link to="web/new-posts"> What's New </Link>
    //     },
    //     {
    //       key: 'media-gallery',
    //       label: <Link to="web/gallery"> Gallery </Link>
    //     }
    //   ]
    // },
    {
      key: 'more',
      label: <span>More <Icon path={mdiMenuDown} size="20px" /></span>,
      children: [
        {
          key: 'more-about-us',
          label: <Link to="/web/about-us"> About Us </Link>
        },
        {
          key: 'more-contact-us',
          label: <Link to="/web/contact-us"> Contact Us </Link>
        },
        {
          key: 'more-contact-agents',
          label: <Link to="/web/contact-agents"> Contact Agents </Link>
        },
      ]
    },
    // {
    //   key: 'sign-in',
    //   label: this.props.isUserSignedIn ? this.SignOutButton("sign-out-menu") : this.PartnerSignInButton("sign-in-menu")
    // },
  ]

  state = {
    open: false,
    current: "",
  }

  constructor(props:any){
    super(props);
  }


  componentDidMount() {
    this.setLocation();
  }


  private setLocation(){
    const location = this.props.location
    const activeUrlKey = location.pathname.split("/").pop() || "app";
    this.setState({current: activeUrlKey});
  }


  onClick: MenuProps['onClick'] = (e) => {
    this.setState({open: false, current: e.key})
  };

  showDrawer() {
    this.setState({open: true});
  };

  onClose() {
    this.setState({open: false});
  };

  customExpandIcon(props) {
    if (props.isOpen) {
        return <a className="custom-expand-submenu-icon" onClick={e => {
            props.onExpand(props.record, e);
        }}><Icon path={mdiMenuUp} size={1} /></a>
    } else {
        return <a className="custom-expand-submenu-icon" onClick={e => {
            props.onExpand(props.record, e);
        }}><Icon path={mdiMenuDown} size={1} /></a>
    }
  }

  logout(){
    UserApi.logout()
      .then(success => {
        if(success){
          this.props.navigate('/web/sign-in');
          this.props.navigate(0);
        }
      })
      .catch(error => {
        notification.error({ message: 'An error occured while signing out.'});
      });
  }

  render(){
    const {open, current } = this.state;
    return (
      <div className="header">
          <a href="/web" className="logo">
            <picture>
              <source media="(min-width: 769px)" srcSet="/iceholidays-assets/images/GD_logo.png" />
              <source media="(max-width: 768px)" srcSet="/iceholidays-assets/images/GD_logo-mobile.png" />
              <img src="/iceholidays-assets/images/GD_logo.png" alt="GD Logo" />
            </picture>
          </a>
          <Menu mode="horizontal" items={this.items} onClick={this.onClick} selectedKeys={[current]} className="nav-menu"/>
  
        <div id="nav-buttons">
          {/* {this.props.isUserSignedIn ? this.SignOutButton("sign-out-mobile") : this.PartnerSignInButton("sign-in-mobile")} */}
  
          <Button id="toggle-menu" type="primary" onClick={()=>this.showDrawer()}>
            <Icon path={mdiMenu} size="25px" />
          </Button>
        </div>
  
        <Drawer title={null} onClose={()=>this.onClose()} open={open} id="nav-drawer">
          <Menu items={this.items} mode="inline" expandIcon={(props) => this.customExpandIcon(props)} onClick={this.onClick} selectedKeys={[current]} className="nav-menu_mobile"/>
        </Drawer>
      </div>
    )
  }
  
}

export default withLocation(Header);